<template>
  <div>
    <!-- 车险报价分享 -->
    <div class="car">
      <div class="C-top">
        <span>{{ vehicleInfo.licenseNo }}({{ vehicleInfo.oriModelName }})</span>
        <span>{{ carOwner }}</span>
      </div>
      <div class="C-botton">
        <div class="C-B-top">
          <span v-if="vehicleInfo.import_Flag">车系：{{ vehicleInfo.import_Flag }}&emsp;</span>
          <span v-if="vehicleInfo.exhaustCapacity">排量：{{ vehicleInfo.exhaustCapacity }}&emsp;</span>
          <span v-if="vehicleInfo.marketYear">年款：{{ vehicleInfo.marketYear }} &emsp; </span>
          <span v-if="vehicleInfo.seatCount">{{ vehicleInfo.seatCount }}座 &emsp;</span>
          <span>车价：{{ vehicleInfo.purchasePrice }}</span>
        </div>
        <p>行业车型编码：{{ vehicleInfo.platVehicleCode }}</p>
        <p>投保人：{{ insuredName }}</p>
      </div>
    </div>
    <!-- 保费 -->
    <div class="content">
      <div class="Con-top">
        <p v-if="JQPremium">
          交强险起止：<span>{{ baseInfo.startDateCI }} {{ baseInfo.startHourCI }}时</span> 至 <span>{{ baseInfo.endDateCI }} {{ baseInfo.endHourCI }}时</span>
        </p>
        <p v-if="premium">
          商业险起止：<span>{{ baseInfo.startDate }} {{ baseInfo.startHour }}时</span> 至 <span>{{ baseInfo.endDate }} {{ baseInfo.endHour }}时</span>
        </p>
      </div>
      <div class="C-sum">
        <h5>保费合计</h5>
        <b>￥{{ sumPremium }}</b>
      </div>
      <div v-if="JQPremium" class="C-sum">
        <h6>交强险保费</h6>
        <span>￥{{ JQPremium }}</span>
      </div>
      <div v-if="SumPayTaxShow" class="C-sum">
        <h6>车船税({{ vessel }})</h6>
        <span>￥{{ SumPayTax }}</span>
      </div>
      <div v-if="premium" class="Total" @click="activity">
        <h6>商业险合计</h6>
        <span v-if="adjustment">保额</span>
        <div class="T-right">
          <span>￥{{ premium }}</span>
          <img :src="imageUrl" alt="">
        </div>
      </div>
      <!-- 展开 -->
      <div v-for="(item,index) in insuredFeeList" v-show="Risk" :key="index" class="C-content">
        <div class="Risksum">
          <div class="bujimpei">
            <span>{{ item.kindName }}</span>
            <span v-if="item.valuest">({{ item.valuest }})</span>
            <span v-if="item.ThreeParty">({{ item.ThreeParty }})</span>
          </div>
          <span>{{ item.amountNumber }}</span>
          <span>￥{{ item.premium }}</span>
        </div>
      </div>
      <div v-if="Risk" class="Discount">
        <span>商业险折扣</span>
        <b>{{ totalPrice }}</b>
      </div>
    </div>

    <!-- 车+意险 -->
    <div v-if="Driving" class="CarBottom">
      <h3>驾乘私家车意外险</h3>
      <p>
        <span>保障计划</span>
        <span>{{ carPolicySubInfoLis.riskName }}</span>
      </p>
      <p>
        <span>投保份数</span>
        <span>{{ carPolicySubInfoLis.quantity }}</span>
      </p>
      <p>
        <span>保额</span>
        <span class="Tspan">¥{{ carPolicySubInfoLis.sumAmount }}</span>
      </p>
      <p class="Tep">
        <span>保费</span>
        <span class="Tspan">¥{{ carPolicySubInfoLis.sumPremium }}</span>
      </p>
    </div>
    <van-toast id="van-toast" />
  </div>
</template>
<script>
import api from '@/api/api.js'
import { Toast } from 'vant'
import { toDecimal2 } from '@/utils/checkFormat.js'
export default {
  data() {
    return {
      imageUrl: api.imgAllUrlZSB + '/botton20190912.png',
      adjustment: true, // 保额
      Risk: true,
      Driving: false,
      vessel: '', // 车船税
      agentName: '', // 代理人
      vehicleInfo: {
        // licenseNo: '', // 车牌号
        // oriModelName: '', // 型号
        // exhaustCapacity: '', // 排量
        // seatCount: '', // 座位
        // purchasePrice: '', // 新车购置价
        // platVehicleCode: '', // 行业车型编码
        // marketYear: '', // 年款,
        // import_Flag: '' // 车系
      },
      insuredName: '', // 投保人姓名
      Insured: {
        insuredName: '' // 被保人姓名
      },
      carOwner: '', // 车主姓名
      baseInfo: {
        // endDateCI: '', // 交强险终保时间
        // endHourCI: '', // 交强险终保小时
        // startDateCI: '', // 交强险起保时间
        // startHourCI: '', // 交强险起保小时
        // endDate: '', // 车险商业险终保时间
        // endHour: '', // 车险商业险终保小时
        // startDate: '', // 车险商业险起保时间
        // startHour: '' // 车险商业险起保小时
      },
      carPolicySubInfoLis: { // 车+意
        quantity: '',
        riskName: '',
        sumAmount: '',
        sumPremium: ''
      },
      insuredFeeList: [], // 各类险别
      arrData: [], // 不计免赔组
      Holiday: false, // 节假日组
      sumPremium: '', // 保费合计
      JQPremium: '', // 交强费用
      premium: '', // 商业费用
      SumPayTax: '', // 车船
      totalPrice: '', // 折扣
      SumPayTaxShow: true, // 车船显示隐藏
      SYshow: true, // 商业显示隐藏
      JQshow: true // 交强显示隐藏
    }
  },
  mounted() {
    const param = {
      url: window.location.href,
      wxType: '5'
    }
    console.log(window.location.href)
    this.$http.post(api.getWxTicket, param)
      .then(res => {
        wx.config({
          beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: api.appId, // 必填，企业微信的corpID
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
          jsApiList: ['onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        })
        this.share()
      })
      .catch(error => {
        console.log(error)
      })
    const URL = window.location.href
    const receive = URL.split('?')[1].split('#')[0].split('&')
    let orderId = ''
    let discount = ''
    receive.forEach(value => {
      if (value.split('=')[0] === 'orderId') {
        orderId = value.split('=')[1]
      }
      if (value.split('=')[0] === 'discount') {
        discount = value.split('=')[1]
      }
    })
    const data = orderId
    this.getDetail(data)
    this.totalPrice = discount
  },
  methods: {
    share() {
      const URL = window.location.href
      const that = this
      wx.ready(function() {
        // 分享给好友
        wx.onMenuShareAppMessage({
          title: '车险报价', // 分享标题
          desc: '一诺紫金，共创价值', // 分享描述
          link: URL, // 分享链接
          imgUrl: that.shareLogo, // 分享图标
          success: function() {
          },
          cancel: function() {
          }
        })
      })
    },
    getDetail(item) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        message: '加载中',
        loadingType: 'spinner',
        mask: true
      })
      this.$http.post(api.queryOrderDetail + '?orderId=' + item + '&fileContentFlag=0')
        .then(res => {
          if (res.data.rtnCode === '0000') {
            const data = res.data.resultObj
            if (data.vehicleInfo.noLicenseFlag === '1' && data.vehicleInfo.licenseNo !== null) {
              this.setlicenseNo(data.vehicleInfo.licenseNo)
            } else {
              this.vehicleInfo.licenseNo = '新车未上牌'
            }
            this.sumPremium = toDecimal2(data.orderAmount)
            this.vehicleInfo = data.vehicleInfo
            this.insuredName = data.insuredList[0].insuredName // 投保人姓名
            this.carOwner = data.carOwnerInfo.carOwner // 车主姓名
            this.baseInfo = data.baseInfo
            this.agentName = data.agentName // 代理人
            this.deleteVehicle(data.insuredFeeListUnprocessed)
            if (data.carPolicySubInfoList.length !== 0 && data.carPolicySubInfoList[0].riskCode !== '') {
              this.Driving = true
              this.carPolicySubInfoLis = data.carPolicySubInfoList[0]
              this.carPolicySubInfoLis.sumAmount = toDecimal2(this.carPolicySubInfoLis.sumAmount, 2)
              this.carPolicySubInfoLis.sumPremium = toDecimal2(this.carPolicySubInfoLis.sumPremium, 2)
            } else {
              this.Driving = false
            }
            switch (data.taxRelifInfo.taxRelifFlag) {
              case '1':
                this.vessel = '正常缴税'
                break
              case '2':
                this.vessel = '免税'
                break
              case '3':
                this.vessel = '减税'
                break
              case '4':
                this.vessel = '完税'
                break
              case '5':
                this.vessel = '不征'
                break
            }
            data.planList.forEach(planListItem => {
              if (planListItem.riskCode === '0501') {
                this.premium = toDecimal2(planListItem.planFee)
              }
              if (planListItem.riskCode === '0590') {
                this.JQPremium = toDecimal2(planListItem.planFee)
              }
            })
            if (data.carShipTax.sumPayTax === null) {
              this.SumPayTax = '0.00'
              this.SumPayTaxShow = false
            } else {
              this.SumPayTax = toDecimal2(data.carShipTax.sumPayTax)
              this.SumPayTaxShow = true
            }
          }
          Toast.clear()
        })
        .catch(error => {
          Toast.clear()
          console.log(error)
        })
    },
    // 剔除机动车交通险
    deleteVehicle(arr) {
      arr.forEach(item => {
        item.premium = toDecimal2(item.premium)
        this.insuredFeeList.push(item)
      })
      this.insuredFeeList.forEach(item => {
        if (item.kindCode === 'F' || item.kindCode === 'Q4') {
          // if (item.modeCode === '2') {
          //   item.amountNumber = '进口'
          // } else if (item.modeCode === '1') {
          //   item.amountNumber = '国产'
          // }
        } else {
          const amountNum = Number(item.amount)
          let n = 10000
          let s = '万'
          const y = '元'
          if (amountNum < 10000 && amountNum > 1000) {
            n = 1000
            s = '千'
          } else if (amountNum < 1000 && amountNum > 0) {
            n = 100
            s = '百'
          } else if (amountNum > 10000) {
            n = 10000
            s = '万'
          } else {
            item.amountNumber = ''
          }
          if (amountNum) {
            const quantity = Math.round(amountNum / n * 100) / 100
            if (quantity === parseInt(quantity)) {
              item.amountNumber = Math.round(amountNum / n * 100) / 100 + s
            } else {
              item.amountNumber = amountNum + y
            }
          }
        }
      })
    },
    // 车牌空格
    setlicenseNo(val) {
      this.vehicleInfo.licenseNo = val.slice(0, 2) + '  ' + val.slice(2)
    },
    activity() {
      this.Risk = !this.Risk
      this.adjustment = !this.adjustment
      if (this.Risk === true) {
        this.imageUrl = api.imgAllUrlZSB + '/botton20190912.png'
      } else {
        this.imageUrl = api.imgAllUrlZSB + '/Top20190912.png'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "./ShareQuote.scss"
</style>



// WEBPACK FOOTER //
// src/pages/ShareQuote/ShareQuote.vue